const reatailmediaApi = process.env.BFF_RETAIL_MEDIA

export { reatailmediaApi }
